/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgNoBpArm = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M14 6a4 4 0 1 0-8 0 4 4 0 0 0 8 0zm-4-2a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm5 7H7.151l-4.865 4.967 1.428 1.4 2.857-2.917V22h2v-2h2.572v2h2v-9H15zm-3.857 2v5H8.57v-5zm4.15-3.293L17.586 12l-2.293 2.293 1.414 1.414L19 13.414l2.293 2.293 1.414-1.414L20.414 12l2.293-2.293-1.414-1.414L19 10.586l-2.293-2.293z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgNoBpArm as NoBpArm };
